import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

export const OtpModal = ({ show, onHide, onSubmit, error, resendOtp }) => {
  const [otp, setOtp] = useState("");
  const [resendTimer, setResendTimer] = useState(120);
  const [canResend, setCanResend] = useState(false);
  const [resendSuccess, setResendSuccess] = useState(false);

  useEffect(() => {
    if (show) {
      setOtp("");
      setResendTimer(120);
      setCanResend(false);
      setResendSuccess(false);
    }
  }, [show]);

  useEffect(() => {
    let interval;
    if (!canResend && resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    } else if (resendTimer === 0) {
      setCanResend(true);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [resendTimer, canResend]);

  const handleResend = () => {
    setResendTimer(120);
    setCanResend(false);
    resendOtp();
    setResendSuccess(true);
    // Hide success message after 5 seconds
    setTimeout(() => setResendSuccess(false), 5000);
  };

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header closeButton className="border-0 pb-0 signin-input">
        <Modal.Title className="w-100 text-center fw-bold fs-3">
          Verify Your Number
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="signin-input">
        <p className="text-center text-muted mb-2 signin-input">
          We've sent a 6-digit verification code to your WhatsApp.
        </p>

        <Form.Group>
          <Form.Control
            type="text"
            value={otp}
            maxLength={6}
            onChange={(e) => setOtp(e.target.value)}
            placeholder="••••••"
            className="text-center fs-4 py-2 border border-primary-subtle rounded signin-input"
            style={{ fontSize: 14, letterSpacing: "8px", fontWeight: "500" }}
          />
        </Form.Group>

        {error && (
          <div className="text-danger text-centermb-2" style={{ fontSize: "16px", textAlign: 'center', marginTop: 10 }}>
            {error}
          </div>
        )}

        <div className="text-center mt-3 signin-input">
          {canResend ? (
            <Button
              id="sign-in-button"
              variant="link"
              onClick={handleResend}
              className="text-primary fw-semibold p-0"
            >
              Resend OTP
            </Button>
          ) : (
            <span className="text-muted">Resend OTP in {resendTimer}s</span>
          )}
        </div>

        {resendSuccess && (
          <p
            className="text-success text-center mt-2"
            style={{ fontSize: "14px" }}
          >
            A new OTP has been sent to your number.
          </p>
        )}
      </Modal.Body>

      <Modal.Footer className="border-0 pt-0 justify-content-between signin-input">
        <Button variant="outline-secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          disabled={otp.length !== 6}
          onClick={() => onSubmit(otp)}
        >
          Verify
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
